import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import swal from 'sweetalert';

const InviteCustomer = forwardRef((props, ref) => {
  const [inviteModal, setInviteModal] = useState(false);
  const [data1, setData1] = useState([]);
  const [user, setUser] = useState({});
  const [showhide, setShowhide] = useState(true);
  const [errors, setErrors] = useState('');
  
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
      getExpensis();
      setUser(props.data);

      // Conditionally show/hide the employee field
      if (props.data.EmployeeID == null) {
        setShowhide(true);
      } else {
        setShowhide(false);
      }

      props.show(false);
    }
  }));

  // Update user state when props.data changes
  useEffect(() => {
    setUser(props.data);
    if (props.data.EmployeeID == null) {
      setShowhide(true);
    } else {
      setShowhide(false);
    }
  }, [props.data]);

  // Handle numeric validation for the Amount field
  const handleInputChange1 = (e) => {
    setErrors('');
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setUser({ ...user, Amount: value });
    } else {
      setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة");
    }
  };

  // Submit the form to update expenses
  const onSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting user data:', user);

    axios.put(`https://suhba.education.com.ly/back/api/expenses/${user.ExpenseID}`, user)
      .then(() => {
        setUser({});
        props.parentFunction();
        swal("تمت عملية التعديل بنجاح");
        setInviteModal(false);
      })
      .catch((error) => {
        if (error.response) {
          console.error('Error response:', error.response.data);
        } else if (error.request) {
          console.error('Error request:', error.request);
        } else {
          console.error('Error message:', error.message);
        }
        swal("حدث خطأ أثناء التعديل", '', 'error');
      });
  };

  // Fetch expense types from API
  const getExpensis = () => {
    axios.get('https://suhba.education.com.ly/back/api/fillexpeses')
      .then(({ data }) => {
        setData1(data.ExpenseType);
      })
      .catch((error) => {
        console.error("Error fetching expense types:", error);
      });
  };

  return (
    <>
      <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">تعديل بيانات المصروفات</h1>
            <button type="button" className="btn-close" onClick={() => setInviteModal(false)}></button>
          </div>
          <form onSubmit={onSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-xl-12">
                  {/* Employee field (conditionally hidden) */}
                  <div className="row">
                    <div className="col-xl-12">
                      <label hidden={showhide} className="form-label">
                        اسم الموظف<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          hidden={showhide}
                          type="text"
                          className="form-control"
                          disabled
                          name="EmployeeID"
                          value={user.FirstName || ''}
                        />
                      </div>
                    </div>
                    {/* Expense Date */}
                    <div className="col-xl-6">
                      <label className="form-label">
                        تاريخ الصرف<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          className="form-control"
                          name="ExpenseDate"
                          value={user.ExpenseDate || ''}
                          onChange={(e) => setUser({ ...user, ExpenseDate: e.target.value })}
                        />
                      </div>
                    </div>
                    {/* Amount */}
                    <div className="col-xl-6">
                      <label className="form-label">
                        القيمة<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="Amount"
                          value={user.Amount || ''}
                          onChange={handleInputChange1}
                        />
                      </div>
                      {errors && <div className="alert alert-danger">{errors}</div>}
                    </div>
                  </div>

                  {/* Expense Type */}
                  <div className="col-xl-12">
                    <label className="form-label mt-3">
                      دالك لــ<span className="text-danger">*</span>
                    </label>
                    <select
                      className="default-select form-control"
                      name="ExpenseTypeID"
                      value={user.ExpenseTypeID || ''}
                      onChange={(e) => setUser({ ...user, ExpenseTypeID: e.target.value })}
                    >
                      <option value="">اختر من القائمة</option>
                      {data1.map((row) => (
                        <option key={row.ExpenseTypeID} value={row.ExpenseTypeID}>
                          {row.TypeName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Hidden user ID and Expense ID */}
                  <input type="hidden" name="UserID" value="1" />
                  <input type="hidden" name="EexpenseID" value={props.ExpenseId} />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                حفظ
              </button>
              <button type="button" className="btn btn-danger light" onClick={() => setInviteModal(false)}>
                إلغاء
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
});

export default InviteCustomer;
